/**
 * @file: constrainScreenOrientationIfNeeded.web.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */
import type { PresentationMode } from '@euler/app/components/PresentationModeContext';

export async function constraintScreenOrientationForPreferredOrientationMode(
  _preferredPresentationMode: PresentationMode | null | undefined,
  _isHub: boolean,
) {}

export async function constrainScreenOrientationIfNeeded(_isHub: boolean) {}
